import camelCase from 'lodash/camelCase';
import isArray from 'lodash/isArray';
import isDate from 'lodash/isDate';
import isObject from 'lodash/isObject';

export function camelCaseObjectKeys(data) {
    if (isArray(data)) {
        return data.map(camelCaseObjectKeys);
    }

    if (isObject(data)) {
        return Object.entries(data).reduce((formatted, [key, value]) => {
            formatted[camelCase(key)] =
                (isObject(value) || isArray(value)) && !isDate(value)
                    ? camelCaseObjectKeys(value)
                    : value;

            return formatted;
        }, {});
    }

    return data;
}
